import type { PointType } from '../map-types';

type FeatureType = {
  type: 'Feature';
  properties: {
    id: string;
  };
  geometry: {
    type: 'Point';
    coordinates: { lng: number; lat: number };
  };
};

export const createPointsGeoJson = (
  points: PointType[] = []
): { type: string; features: FeatureType[] } => {
  return {
    type: 'FeatureCollection',
    features: points.map((point) => {
      return {
        type: 'Feature',
        properties: {
          id: point.id
        },
        geometry: {
          type: 'Point',
          coordinates: point.coordinates
        }
      };
    })
  };
};
